import { c as _c } from "react/compiler-runtime";
import { XCircleIcon } from "lucide-react";
import Image from "next/image";
import { cn } from "@/lib/utils";
export const SingleImageInput = t0 => {
  const $ = _c(29);
  const {
    name,
    image,
    size,
    onDelete,
    onLoad,
    preload,
    isUploading,
    width: t1,
    height: t2
  } = t0;
  const width = t1 === undefined ? 300 : t1;
  const height = t2 === undefined ? 300 : t2;
  const aspectRatio = width && height ? `${width} / ${height}` : "1";
  const imageWidth = size === "large" ? width : width / 3 - 16;
  const imageHeight = size === "large" ? height : height / 3 - 16;
  let t3;
  if ($[0] !== aspectRatio) {
    t3 = {
      aspectRatio
    };
    $[0] = aspectRatio;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = preload || image;
  let t5;
  if ($[2] !== name || $[3] !== t4) {
    t5 = <input type="hidden" name={name} value={t4} />;
    $[2] = name;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== imageHeight || $[6] !== imageWidth || $[7] !== name || $[8] !== onLoad || $[9] !== preload) {
    t6 = preload && <Image alt={name ?? ""} className="pointer-events-none absolute opacity-0" width={imageWidth} height={imageHeight} src={preload} onLoad={onLoad} draggable="false" />;
    $[5] = imageHeight;
    $[6] = imageWidth;
    $[7] = name;
    $[8] = onLoad;
    $[9] = preload;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = name ?? "";
  let t8;
  if ($[11] !== image || $[12] !== imageHeight || $[13] !== imageWidth || $[14] !== onLoad || $[15] !== t7) {
    t8 = <Image alt={t7} className="w-full object-cover h-full rounded-md" width={imageWidth} height={imageHeight} src={image} onLoad={onLoad} draggable="false" />;
    $[11] = image;
    $[12] = imageHeight;
    $[13] = imageWidth;
    $[14] = onLoad;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isUploading) {
    t9 = isUploading && <div aria-busy={true} className="absolute bottom-0 h-1 w-full animate-[moving-gradient] bg-linear-to-r from-blue-400 via-blue-800 to-blue-400 shadow-xs duration-1000 [animation-iteration-count:infinite] [background-size:50%_100%]" />;
    $[17] = isUploading;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== onDelete || $[20] !== size) {
    t10 = onDelete && <button type="button" className={cn("absolute right-0 z-20 top-0 p-1 opacity-70 transition-opacity hover:opacity-100", size === "large" && "p-1.5")} onClickCapture={e => {
      e.preventDefault();
      onDelete();
    }} title="Delete image"><XCircleIcon className="h-4 w-4 fill-white" /><span className="sr-only">Delete image</span></button>;
    $[19] = onDelete;
    $[20] = size;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t3 || $[24] !== t5 || $[25] !== t6 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div className="group relative w-full rounded-md object-cover" style={t3}>{t5}{t6}{t8}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t3;
    $[24] = t5;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};